import React from 'react'
import './Info.css'

import controlIcon from "./imgs/control.png"
import githubIcon from "./imgs/github.png"
import folderIcon from "./imgs/folder.png"
import contactIcon from "./imgs/contact.png"




import Project from '../Project/Project'
import InfoString from '../InfoString/InfoString'


// Tech images.
import css from '../Project/imgs/techImgs/css.png'
import django from '../Project/imgs/techImgs/django.png'
import html from '../Project/imgs/techImgs/html.svg'
import keras from '../Project/imgs/techImgs/keras.png'
import mysql from '../Project/imgs/techImgs/mysql.png'
import postgresql from '../Project/imgs/techImgs/postgresql.png'
import python from '../Project/imgs/techImgs/python.png'
import tensorflow from '../Project/imgs/techImgs/tensorflow.png'
import unity from '../Project/imgs/techImgs/unity.png'
import flask from '../Project/imgs/techImgs/flask.svg'
import react from '../Project/imgs/techImgs/react.png'
import selenium from '../Project/imgs/techImgs/selenium.png'
import { Fragment } from 'react'






// Thumbnails
import GToolT from './imgs/appsImgs/GTool.png'
import BotmbiT from './imgs/appsImgs/Botmbi.png'
import ConvToolT from './imgs/appsImgs/ConvTool.png'
import DeeptransToolT from './imgs/appsImgs/DeeptransTool.png'
import DownToolT from './imgs/appsImgs/DownTool.png'
import MovieToolT from './imgs/appsImgs/MovieTool.png'
import TheWildToolT from './imgs/appsImgs/TheWildTool.png'
import AsegToolT from './imgs/appsImgs/AsegTool.png'
import GToolAT from './imgs/appsImgs/GToolA.png'






export default function Info(props){
    
    const image = props.image
    const title = props.title
    const description = props.desc
    const img = props.img_main


    const projectsBool = props.projects
    const moreBool = props.more_info
    const pinBool = props.pinn_app

    
    var imageIcon = ''

    if (image === 'control') {
        imageIcon = controlIcon
    } else if (image === 'github') {
        imageIcon = githubIcon
    } else if (image === 'folder') {
        imageIcon = folderIcon
    } else if (image === 'contact') {
        imageIcon = contactIcon
    }



    return(
        <div className="info_div">

            <div className="top_div">

                {imageIcon && (

                    <img src={imageIcon} alt="#" className='image_info' />

                )}
                

                <h2 className="title_info">{title}</h2>

            </div>

            <div className="info_description_div">

                {description}


                {img && (
                    <a href='https://github.com/ElHaban3ro' target="__blank">
                        
                        <img src={img} alt="#" className='targetInfo' />
                    </a>
                )}



                {projectsBool && (
                    <div className='projetcs_div_main'>

                        <Project 
                        name='GtoolA' 
                        description='AI job designed to automate jobs within SAMP, using a CNN and proprietary data.'
                        thumbnail={GToolAT}

                        tech_list={[python, react, tensorflow]}
                        go='https://github.com/ElHaban3ro/GToolA'
                        />

                        <Project 
                        name='AsegTool' 
                        description='AsegTool is a tool designed to generate a segmentation file that is usable within my other tool. 🌵'
                        thumbnail={AsegToolT}

                        tech_list={[react, css, html]}
                        go='https://asegtool.vercel.app/'
                        />

                        <Project 
                        name='TheWildTool' 
                        description='TheWildTool is a tool developed with the main objective of saving time when working with audio datasets. Either to prepare them, to get them or to train a model with them. 🤖'
                        thumbnail={TheWildToolT}

                        tech_list={[python, tensorflow]}
                        go='https://github.com/ElHaban3ro/TheWildTool'
                        />

                        <Project 
                        name='GTool' 
                        description='Generate cards with useful data from different applications (for now only GitHub) and insert them in your web/app or wherever you want c: (API APP) 🎯'
                        thumbnail={GToolT}

                        tech_list={[python, flask]}
                        go='https://github.com/ElHaban3ro/GTool'
                        />


                        <Project 
                        name='Botmbi' 
                        description="Discord bot (open source) to make content requests to Ombi. Improve this and let's grow Botmbi together. 🎃"
                        thumbnail={BotmbiT}

                        tech_list={[python, css, html]}
                        go='https://elhaban3ro.github.io/Botmbi/'
                        />



                        <Project 
                        name='MovieTool' 
                        description='Download your movies and series, automate everything and create your own "Netflix" 100% functional (and with more content than Netflix) making use of Plex, Ombi and other technologies. ⭐'
                        thumbnail={MovieToolT}

                        tech_list={[python, flask, react, css]}
                        go='https://github.com/ElHaban3ro/MovieTool'
                        />




                        <Project 
                        name='DownTool' 
                        description='This app was developed with the aim of being able to download videos from YouTube en masse without having to deal with pages full of advertising. :)'
                        thumbnail={DownToolT}
                        tech_list={[python]}
                        go='https://github.com/ElHaban3ro/DownTool-YT-DLP-GUI'/>




                        <Project 
                        name='ConvTool' 
                        description='A unified package to convert your videos or images to another image/video format. Convert a whole folder from that format to a different one, or if you prefer, convert just one! 🥵'
                        thumbnail={ConvToolT}

                        tech_list={[python]}
                        go='https://github.com/ElHaban3ro/ConvTool'
                        />



                        <Project 
                        name='DeeptransTool' 
                        description="Use the world's best translator (DeepL) to translate your text files or text itself!! All without having to provide your credit card or be limited by the API. 🐸"
                        thumbnail={DeeptransToolT}

                        tech_list={[python, selenium]}
                        go='https://github.com/ElHaban3ro/GTool'
                        />




                    </div >

                )}

                {moreBool && (

                    <div className="more_info_div_main">
                        
                        <InfoString img='email' content='habanferd@gmail.com' />
                        <InfoString img='ubi' content='Colombia, Cundinamarca.' />
                        <InfoString img='linkedin' link={true} content='https://linkedin.com/in/Elhaban3ro' />
                        <InfoString img='twitter' link={true} content='https://twitter.com/Elhaban3ro' />

                    </div>

                )}

                {pinBool && (
                    <div className='projetcs_div_main'>
                    
                        
                    <Project 
                        name='DownTool' 
                        description='This app was developed with the aim of being able to download videos from YouTube en masse without having to deal with pages full of advertising. :)'
                        thumbnail={DownToolT}
                        tech_list={[python]}
                        go='https://github.com/ElHaban3ro/DownTool-YT-DLP-GUI'/>
                        
                    </div>
                )}


            </div>


        </div>
    )
}